// PROFILE COMPLETION
export const PROFILE_COMPLETION_LIST_SUCCESS = 'PROFILE_COMPLETION_LIST_SUCCESS';

// LOADING
export const SET_LOADING = 'SET_LOADING';

// POINT OF SALE
export const SET_SELECTED_POINT_OF_SALE_GUID = 'SET_SELECTED_POINT_OF_SALE_GUID';
export const POINT_OF_SALE_LIST_SUCCESS = 'POINT_OF_SALE_LIST_SUCCESS';

// OPTIONS
export const OPTIONS_SUCCESS = 'OPTIONS_SUCCESS';

// GROUPS
export const GROUP_TYPE_LIST_SUCCESS = 'GROUP_TYPE_LIST_SUCCESS';

// MODULES
export const MODULE_STATUS = 'MODULE_STATUS';

// LANGUAGES
export const MODEL_LANGUAGE_LIST_SUCCESS = 'MODEL_LANGUAGE_LIST_SUCCESS';
